import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { ENUM_MortgageExpiryType } from '@api-new/common';
import { Store } from '@ngrx/store';
import { DashboardWidget } from '@platform/dashboard/models/dashboard-news-banner.model';
import { paths } from '@platform/paths';
import { VisibilityDirective } from '@shared-lib/directives/visibility.directive';
import { BetterDealTicketCarouselComponent } from '@shared/components/better-deal-ticket-carousel/better-deal-ticket-carousel.component';
import { HasCompanyClientUiSettingsDisabledDirective } from '@shared/directives/has-company-client-ui-settings-disabled.directive';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { AnalyticsEvent } from '@shared/enums/analytics-enums';
import { BrandingAssetPathPipe } from '@shared/pipes/branding-image-path.pipe';
import { AnalyticsService } from '@shared/services/analytics.service';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { NavigationService } from '@shared/services/navigation.service';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { ButtonDirective } from 'primeng/button';
import { WidgetHeaderComponent } from '../widget-header/widget-header.component';

@Component({
  selector: 'cp-widget-better-deal',
  imports: [
    CommonModule,
    BetterDealTicketCarouselComponent,
    VisibilityDirective,
    WidgetHeaderComponent,
    ButtonDirective,
    BrandingAssetPathPipe,
    HasCompanyClientUiSettingsEnabledDirective,
    HasCompanyClientUiSettingsDisabledDirective,
  ],
  templateUrl: './widget-better-deal.component.html',
  styleUrl: './widget-better-deal.component.scss',
})
export class WidgetBetterDealComponent implements OnInit {
  @Input({ required: true }) widget: DashboardWidget;

  private readonly navigationService = inject(NavigationService);
  private readonly analytics = inject(AnalyticsService);
  private readonly globalStore = inject(Store);

  @ViewChild('bestDealVid') bestDealVid: ElementRef;

  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);

  protected playVideoTriggered = false;
  protected videoEnded = false;
  protected muted = true;
  protected isExpired = false;

  protected readonly paths = paths;
  protected readonly showMortgageEditingKey: CompanyClientUISettingsKey = 'showMortgageEditing';
  protected readonly showOnlyBestDealInComparisonResults: CompanyClientUISettingsKey = 'showOnlyBestDealInComparisonResults';

  ngOnInit(): void {
    this.isExpired = this.widget.mortgage.mortgageExpiryType == ENUM_MortgageExpiryType.MORTGAGE_EXPIRY_TYPE_EXPIRED;
  }

  seeMortgage(): void {
    this.navigationService.navigate([paths.PLATFORM, paths.platform.MORTGAGE_DETAIL, this.widget.mortgage.id]);
  }

  seeAll(): void {
    this.analytics.logEvent(AnalyticsEvent.BD_WIDGET_SEE_ALL_CLICK);
    this.navigationService.navigate(['/', paths.PLATFORM, paths.platform.BETTER_DEAL_COMPARISON, this.widget.mortgage.id]);
  }

  playVideo(isVisible): void {
    if (!isVisible) return;
    if (this.videoEnded || this.playVideoTriggered || !this.bestDealVid?.nativeElement) return;
    this.playVideoTriggered = true;
    setTimeout(() => this.bestDealVid?.nativeElement?.play(), 500);
  }
}
